import isInstance from './isInstance.js';

const isNumber = (x) => isInstance(Number, x);
export default isNumber;
